import { FirestoreService } from 'common-lib';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, Subject, Subscription } from 'rxjs';
import { Story } from '../models';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserService } from '../user.service';

declare let tracker: any; // KARTEタグ

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input()
  showHome = false;

  @Input()
  showFind = true;

  @Input()
  showMenu = true;

  @Input()
  story: Story;

  @Input()
  showBack = false;

  @Input()
  backUrl: string = null;

  @Input()
  showFav = false;

  @Input()
  hasFav = false;

  @Output() clickFav: EventEmitter<Story> = new EventEmitter();
  @Output() clickBack: EventEmitter<string> = new EventEmitter();

  anonymous = true;
  user: firebase.User;
  userSub: Subscription;
  profile: any;
  showInvalidProfileModal: boolean = false;
  isCheckProfile: boolean = true;

  constructor(
    private fire: FirestoreService,
    private auth: AngularFireAuth,
    private route: ActivatedRoute,
    private router: Router,
    private users: UserService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showMenu = event.url !== '/menu';
        // プロフィール画面ではプロフィール入力済みチェックを行わないためここでURLをチェック
        this.isCheckProfile = !/^\/profile/.test(event.url);
      }
    });
  }

  ngOnInit() {
    this.userSub = this.auth.user.subscribe(async (user) => {
      this.user = user;
      if (user) {
        this.anonymous = user.isAnonymous;
        this.profile = await this.users.getProfile();
        if (this.profile) {
          await this.checkProfile();
          // プロフィール登録済みなら各情報をKARTEに送信
          // KARTEタグ: 個人情報
          tracker.user({
            user_id: user.uid,
            email: user.email,
            name: this.profile.name,
            subscription: this.profile.optIn,
            company_name: this.profile.companyName,
          });
          // KARTEタグ: ユーザー情報
          tracker.track('attribute', {
            educational_background: this.profile.educationalBackground,
            company_post: this.profile.companyPost,
            parent_job_type: this.profile.jobType,
            annual_income_string: this.profile.annualIncome,
            signup_date: this.user.metadata.creationTime,
            company_optin: this.profile.companyOptIn,
          });
        }
      } else {
        this.anonymous = true;
      }
    });
  }

  async checkProfile() {
    if (!this.isCheckProfile) {
      return;
    }
    // 一度もプロフィール登録を促すモーダルを表示していない場合はチェック
    if (!this.profile.modalClosedAt) {
      this.showInvalidProfileModal = !(await this.users.isValidProfile());
      return;
    }
    // 最後にモーダルを閉じた日時が一定期間経過している場合はチェック
    const modalClosedAt = this.profile.modalClosedAt.toDate().getTime();
    const now = new Date().getTime();
    const diffDay = Math.floor((now - modalClosedAt) / (1000 * 60 * 60 * 24));
    if (diffDay >= 7) {
      this.showInvalidProfileModal = !(await this.users.isValidProfile());
    }
  }

  onClickFav() {
    this.clickFav.emit(this.story);
  }

  back(event: Event) {
    this.clickBack.emit(this.backUrl);
    return false;
  }

  signOut() {
    // KARTEタグ: ログアウト
    tracker.track('login', {
      status: false,
    });

    this.auth.auth.signOut();
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: { v: 'logout' } });
  }
}
